import { render, staticRenderFns } from "./PartnerTemplate.vue?vue&type=template&id=bffffd3e&"
import script from "./PartnerTemplate.vue?vue&type=script&lang=js&"
export * from "./PartnerTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports